var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.search.InvalidSearchTerm)?_c('div',{staticClass:"search-error-message"},[_c('span',[_vm._v(_vm._s(this.errormessageText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }